import Vue from 'vue'
import Toasted from 'vue-toasted'
import store from '../../vue/store'
import clientLocaleBundle from './locales'
import clientConfigurationBundle from './config'
import AdvProductCard from './AdvProductCard.vue'
import config from '../../vue/config/configPlugin'
import locale from '../../vue/locales/localePlugin'
import AdvCartGiftList from './AdvCartGiftList'
import AdvButtonViewBuy from './AdvButtonViewBuy'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import AdvCartProductList from './AdvCartProductList.vue'
import InitialData from '../../vue/data-components/InitialData.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import jqueryVueBridgePlugin from '../../vue/plugins/jqueryVueBridgePlugin'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture'
import CookieModal from './cookies/components/CookieModal.vue'
import CookieSettingsButton from './cookies/components/CookieSettingsButton.vue'
import AdvCartProductCustomizationEditor from './cartProductCustomizations/AdvCartProductCustomizationEditor'
import AdvCartProductCustomizationDisplayValues
from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AfterAddToCartModal from './AfterAddToCartModal.vue'
import ProductPriceChartModal from './product/ProductPriceChartModal.vue'
import AdvCartDeliveryInfo from './AdvCartDeliveryInfo'
import checkoutSuccessLottie from './checkoutSuccessLottie.vue'
import GlassesGroupFiltering from '../../front/vue/glassesGroupFilteringComponents/GlassesGroupFiltering.vue'
import GlassesGroupFilteringMobile from '../../front/vue/glassesGroupFilteringComponents/GlassesGroupFilteringMobile.vue'
import QuickView from './presentation/QuickView.vue'

const CheckoutPage = () => import(/* webpackChunkName: "checkout-page" */ './CheckoutPage.vue')
const googleMapPartners = () => import(/* webpackChunkName: "google-map-partners" */ './googleMaps/components/googleMapPartners.vue')
const AllListingFilters = () => import(/* webpackChunkName: "all-listing-filters" */ './AllListingFilters.vue')
const AdvListingUsedFilters = () => import(/* webpackChunkName: "adv-listing-used-filters" */ './AdvListingUsedFilters.vue')
const AdvButtonViewBuyCombo = () => import(/* webpackChunkName: "adv-button-view-buy-combo" */ './AdvButtonViewBuyCombo.vue')
const AdvProductGallery = () => import(/* webpackChunkName: "adv-product-gallery" */ './AdvProductGallery.vue')
const GiftCardPage = () => import(/* webpackChunkName: "gift-card-page" */ './giftCards/GiftCardPage.vue')
const ContactLensesMetaDropdown = () => import(/* webpackChunkName: "contact-lenses-meta-dropdown" */ './ContactLensesMetaDropdown.vue')
const PrescriptionForm = () => import(/* webpackChunkName: "contact-lenses-meta-dropdown" */ './prescriptionComponents/PrescriptionForm.vue')
const ProductPrescriptionSelect = () => import(/* webpackChunkName: "product-prescription-select" */ './prescriptionComponents/ProductPrescriptionSelect.vue')
const HomeStreamSlider = () => import(/* webpackChunkName: "home-stream-slider" */ './streamSlider/HomeStreamSlider.vue')
const StreamSlide = () => import(/* webpackChunkName: "stream-slide" */ './streamSlider/StreamSlide.vue')
const Reels = () => import(/* webpackChunkName: "reels" */ './streamSlider/Reels.vue')

// import ViberForm from './ViberForm.vue'
// import ViberSignOut from './ViberSignOut.vue'
// import BirthdayForm from './BirthdayForm'

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    CookieModal,
    CookieSettingsButton,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvMinicartGiftChoiceModal,
    AdvHtmlPicture,
    AdvCartProductCustomizationEditor,
    AdvCartProductCustomizationDisplayValues,
    AfterAddToCartModal,
    ProductPriceChartModal,
    HomeStreamSlider,
    StreamSlide,
    AdvProductGallery,
    AdvButtonViewBuyCombo,
    AdvListingUsedFilters,
    AllListingFilters,
    CheckoutPage,
    googleMapPartners,
    AdvCartDeliveryInfo,
    checkoutSuccessLottie,
    GlassesGroupFiltering,
    GlassesGroupFilteringMobile,
    QuickView,
    ContactLensesMetaDropdown,
    GiftCardPage,
    PrescriptionForm,
    ProductPrescriptionSelect,
    Reels
    // ViberForm,
    // ViberSignOut
    // BirthdayForm
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
})
